var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReactivate = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 -960 960 960",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M565-870q136 30 225.5 137.5T880-480q0 89-36 166t-97 132h51q17 0 29.5 12.5T840-140q0 17-12.5 29.5T798-98H638q-17 0-29.5-12.5T596-140v-160q0-17 12.5-29.5T638-342q17 0 29.5 12.5T680-300v65q53-45 84.5-108T796-480q0-113-70-197.5T550-787q-14-3-24-15t-10-26q0-21 14.5-34t34.5-8ZM395-90q-135-30-225-137.5T80-480q0-89 36-166t97-132h-51q-17 0-29.5-12.5T120-820q0-17 12.5-29.5T162-862h160q17 0 29.5 12.5T364-820v160q0 17-12.5 29.5T322-618q-17 0-29.5-12.5T280-660v-65q-53 44-84.5 107.5T164-480q0 113 70 197.5T410-173q14 3 24 15t10 26q0 21-14.5 34T395-90Zm28-221q-8 0-16-3t-14-9L280-437q-12-12-12-29t12-29q12-12 29-12t29 12l85 84 198-197q12-12 29-12t29 12q12 12 12 29t-12 29L453-323q-6 6-14 9t-16 3Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReactivate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reactivate.0d030bc2.svg";
export { ForwardRef as ReactComponent };